<template>
  <div class="row">
    <div class="col-lg-6">
      <div class="row">
        <LoaderButton
          class="ml-3"
          @click="addActives('getData')"
        >
          {{ $t('add_all') }}
        </LoaderButton>

        <LoaderButton
          class="ml-3"
          @click="addActives()"
        >
          {{ $t('add_selection') }}
        </LoaderButton>
      </div>

      <LDBsTable
        url="active"
        defaultSort="createdAt"
        defaultOrder="desc"
        :query="queryToUse"
        :columns="columns"
        :clear="clear"
        :defaultOptions="{ height: '650' }"
      >
        <div class="form-group col-lg-6">
          <label for="model">{{ $t('model') }}</label>
          <Combobox
            multiple
            class="bg-white"
            name='model'
            :placeholder="$t('select_a_item')"
            label="name"
            :getOptionLabel="model => model.name ? model.manufacturer.name + ' / ' + model.name : ''"
            :options="models"
            v-model="query.model"
            :reduce="models => models.id"
          />
        </div>

        <div class="form-group col-lg-6">
          <label for="serie">{{ $t('serie') }}</label>
          <input
            type="text"
            id="serie"
            name="serie"
            class="form-control"
            :placeholder="$t('ph_serie')"
            v-model="query.serie"
            @input="query.serie = query.serie.toUpperCase()"
          >
        </div>

        <div class="form-group col-lg-6">
          <label for="active_type">{{ $t('active_type') }}</label>
          <Combobox
            multiple
            class="bg-white"
            name='actives_type'
            :placeholder="$t('select_a_item')"
            label="name"
            :options="activestypes"
            v-model="query.activeType"
            :reduce="activesTypes => activesTypes.id"
          />
        </div>

        <div class="form-group col-lg-6">
          <label for="location">{{ $t('location') }}</label>
          <Combobox
            class="bg-white"
            name='location'
            :placeholder="$t('select_a_item')"
            :options="locations"
            v-model="query.location"
          />
        </div>

        <div class="form-group col-lg-12">
          <label for="garage_accredited_name">{{ $t('garage_accredited_name') }}</label>
          <Combobox
            :disabled="query.location !== 'OFICINA CREDENCIADA'"
            class="bg-white"
            name='garage_accredited'
            :placeholder="$t('select_a_item')"
            :getOptionLabel="garage => customGarageLabel(garage)"
            :options="garages"
            :reduce="garage => garage.id"
            v-model="query.garageAccredited"
          />
        </div>

        <div class="form-group col-lg-6">
          <label for="status">{{ $t('status') }}</label>
          <Combobox
            class="bg-white"
            name='status'
            :placeholder="$t('select_a_item')"
            label="name"
            :options="allStatus.rows"
            v-model="query.status"
            :reduce="status => status.id"
          />
        </div>

        <div class="form-group col-lg-6">
          <label for="isActive">{{ $t('active') }}</label>
          <Combobox
            class="bg-white"
            name='isActive'
            :placeholder="$t('select_a_item')"
            label="label"
            :initial-value="query.isActive"
            :options="[{ label: 'SIM', value: true }, { label: 'NÃO', value: false } ]"
            v-model="query.isActive"
            :reduce="active => active.value"
          />
        </div>
      </LDBsTable>
    </div>

    <div class="col-lg-6">
      <div class="row">
        <div class="form-group">
          <button
            type="button"
            class="btn btn-danger block ml-3"
            @click="removeActives('getData')"
          >
            {{ $t('remove_all') }}
          </button>
        </div>

        <div class="form-group">
          <button
            type="button"
            class="btn btn-danger block ml-3"
            @click="removeActives()"
          >
            {{ $t('remove_selection') }}
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label for="select_destination">{{ $t('select_destination') }}</label>
            <Combobox
              class="bg-white"
              name='select_destination'
              :hasErrors="errors.has('select_destination')"
              :placeholder="$t('select_a_item')"
              label="name"
              :options="locations"
              :initial-value="dataToMovement.location"
              v-model="dataToMovement.location"
              v-validate="'required'"
            />

            <small v-show="errors.has('select_destination')" class="form-text">
              {{ errors.first('select_destination') }}
            </small>
          </div>
        </div>

        <div class="form-group col-lg-6">
          <label for="status">{{ $t('status') }}</label>
          <Combobox
            :disabled="!dataToMovement.location"
            class="bg-white"
            name='status'
            :hasErrors="errors.has('status')"
            :placeholder="$t('select_a_item')"
            label="name"
            :options="statusByDestiny"
            :initial-value="dataToMovement.status"
            :reduce="status => status.id"
            v-model="dataToMovement.status"
            v-validate="`${validateStatus}`"
          />

          <small v-show="errors.has('status')" class="form-text">
            {{ errors.first('status') }}
          </small>
        </div>
      </div>

      <div class="row" v-show="dataToMovement.location === 'OFICINA CREDENCIADA'">
        <div class="form-group col-12">
          <label for="garage_accredited">{{ $t('garage_accredited') }}</label>
          <Combobox
            class="bg-white"
            name='garage_accredited'
            :hasErrors="errors.has('garage_accredited')"
            :placeholder="$t('select_a_item')"
            :getOptionLabel="garage => customGarageLabel(garage)"
            :options="garages"
            :initial-value="dataToMovement.garageAccredited"
            :reduce="garage => garage.id"
            v-model="dataToMovement.garageAccredited"
            v-validate="`${validateGarage}`"
          />

          <small v-show="errors.has('garage_accredited')" class="form-text">
            {{ errors.first('garage_accredited') }}
          </small>
        </div>
      </div>

      <BootstrapTable
        id="tableDataToMovement"
        ref="tableDataToMovement"
        class="bg-white"
        :columns="columnsDataToMovement"
        :data="dataToMovement.actives"
        @onSort="sort"
        :options="{ locale: 'pt-BR', height: 550 }"
      />

      <LoaderButton
        class="mt-3"
        @click="onClick"
      >
        {{ $t('save') }}
      </LoaderButton>
    </div>

    <!-- MODAL TABLE -->
    <div
      ref='modalService'
      id="modalService"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalService"
      aria-hidden="true"
    >
      <div class="modal-xl modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="modalServiceLabel">Selecione Contrato e Serviço</h5>
          </div>

          <div class="modal-body">
            <b-alert
              :show="alert.show"
              @dismissed='alert.show = false'
              dismissible
              fade
              :variant="alert.type"
            >
              {{ alert.message }}
            </b-alert>

            <div class="row">
              <div class="form-group col-6">
                <label for="contract">{{ $t('contract') }}</label>
                <Combobox
                  class="bg-white"
                  name='contract'
                  :placeholder="$t('select_a_item')"
                  :hasErrors="errors.has('contract')"
                  :initial-value="contract"
                  label="contracts"
                  :options="contracts"
                  v-model="contract"
                  :reduce="contract => contract.id_contrato"
                />

                <small v-show="errors.has('contract')" class="form-text text-muted">
                  {{ errors.first('contract') }}
                </small>
              </div>

              <div class="form-group col-6">
                <label for="services">{{ $t('services') }} (aplicar à todos)</label>
                <Combobox
                  class="bg-white"
                  name='serviceType'
                  :placeholder="$t('select_a_item')"
                  label="name"
                  :options="servicetypes.rows"
                  v-model="serviceToApplyAll"
                  :reduce="serviceType => serviceType.id"
                />
              </div>
            </div>

            <b-table
              id='tableModal'
              responsive='xl'
              bordered
              hover
              :fields="fields"
              :items='trackers'
              class="bg-white"
            >
              <template v-slot:cell(serial)={item}>
                {{ item.model.manufacturer.name + ' / ' + item.model.name + ' / ' + item.serie }}
              </template>

              <template v-slot:cell(services)=value>
                <Combobox
                  class="bg-white"
                  name='serviceType'
                  :placeholder="$t('select_a_item')"
                  label="name"
                  :options="servicetypes.rows"
                  v-model="trackers[value.index].service"
                  :reduce="serviceType => serviceType.id"
                />
              </template>

              <template v-slot:cell(reason)=value>
                <Combobox
                  :disabled="!trackers[value.index].service || trackers[value.index].service === 1 || trackers[value.index].service === 4 || trackers[value.index].service === 5"
                  class="bg-white"
                  name='serviceType'
                  :placeholder="$t('select_a_item')"
                  label="name"
                  :options="maintancereasons"
                  v-model="trackers[value.index].reason"
                  :reduce="serviceType => serviceType.id"
                />
              </template>
            </b-table>

            <div class="row text-right">
              <div class="col-12">
                <b-button class="mt-3" id='closeModal' data-dismiss="modal">{{ $t('close') }}</b-button>
                <b-button class="mt-3 ml-2" variant='primary' @click="movement">{{ $t('save') }}</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL INFO CLIENT -->
    <div
      ref='modalInfoClient'
      id="modalInfoClient"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalInfoClient"
      aria-hidden="true"
    >
      <div class="modal-lg modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5
              class="modal-title"
              id="modalInfoClientLabel"
            >
              Informe {{ dataToMovement.location === 'VEÍCULO DO CLIENTE' ? 'a placa do veículo' : 'o contrato do cliente' }}
            </h5>
          </div>

          <div class="modal-body">

            <div class="form-group" v-if="dataToMovement.location === 'EM POSSE DO CLIENTE'">
              <label for="contract">{{ $t('contract') }}</label>
              <Combobox
                class="bg-white"
                name='contract'
                :placeholder="$t('select_a_item')"
                :hasErrors="errors.has('contract')"
                :initial-value="contract"
                label="contracts"
                :options="contracts"
                v-model="contract"
                :reduce="contract => contract.id_contrato"
              />

              <small v-show="errors.has('contract')" class="form-text text-muted">
                {{ errors.first('contract') }}
              </small>
            </div>

            <div class="form-group col-lg-12" :class="{ 'has-error': errors.has('board') }" v-if="dataToMovement.location === 'VEÍCULO DO CLIENTE'">
              <label for="board">{{ $t('board') }}</label>
              <input
                type="text"
                id="board"
                name="board"
                class="form-control"
                :placeholder="$t('ph_board')"
                v-model="board"
                @input="board = board.toUpperCase()"
              />
            </div>

          </div>

          <div class="modal-footer">
            <b-button
              class="mt-3"
              id='closeModal'
              data-dismiss="modal"
            >
              {{ $t('close') }}
            </b-button>

            <b-button
              class="mt-3 btn-primary"
              id='closeModal'
              data-dismiss="modal"
              @click="movement"
            >
              {{ $t('save') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL EXTRAVIADO -->
    <div
      ref='modalExtraviado'
      id="modalExtraviado"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalExtraviado"
      aria-hidden="true"
    >
      <div class="modal-lg modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="modalExtraviado">
              Selecione Oficina Credenciada ou Cliente
            </h5>
          </div>

          <div class="modal-body">
            <b-form-group :label="$t('lost_by')" v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                id="radio-group-2"
                v-model="lostBy"
                :aria-describedby="ariaDescribedby"
                name="radio-sub-component"
                class="d-flex justify-content-between"
              >
                <b-form-radio value="OUTROS">OUTROS</b-form-radio>
                <b-form-radio value="OFICINA CREDENCIADA">OFICINA CREDENCIADA</b-form-radio>
                <b-form-radio value="CLIENTE">CLIENTE</b-form-radio>
              </b-form-radio-group>
            </b-form-group>

            <div class="row" v-show="lostBy === 'OFICINA CREDENCIADA'">
              <div class="form-group col-12">
                <label for="garage_accredited">{{ $t('garage_accredited') }}</label>
                <Combobox
                  class="bg-white"
                  name='garage_accredited'
                  :hasErrors="errors.has('garage_accredited')"
                  :placeholder="$t('select_a_item')"
                  label="fantasyName"
                  :options="garages"
                  :initial-value="dataToMovement.garageAccredited"
                  :reduce="garage => garage.id"
                  v-model="dataToMovement.garageAccredited"
                  v-validate="`${validateGarage}`"
                />

                <small v-show="errors.has('garage_accredited')" class="form-text">
                  {{ errors.first('garage_accredited') }}
                </small>
              </div>
            </div>

            <div class="form-group" v-show="lostBy === 'CLIENTE'">
              <b-form-checkbox
                switch
                id="checkbox-1"
                name="checkbox-1"
                class="mb-3"
                v-model="contractIsActive"
              >
                Contratos ativos
              </b-form-checkbox>

              <label for="contract">{{ $t('contract') }}</label>
              <Combobox
                :disabled="loadContracts"
                class="bg-white"
                name='contract'
                :placeholder="$t('select_a_item')"
                :hasErrors="errors.has('contract')"
                :initial-value="contract"
                label="contracts"
                :options="contracts"
                v-model="contract"
                :reduce="contract => contract.id_contrato"
              />

              <small v-show="errors.has('contract')" class="form-text text-muted">
                {{ errors.first('contract') }}
              </small>
            </div>

            <div class="input-group mb-2" :class="{ 'has-error': errors.has('board') }" v-show="lostBy === 'CLIENTE'">
              <input
                type="text"
                id="board"
                name="board"
                class="form-control"
                :placeholder="$t('ph_board')"
                v-model="board"
                @input="board = board.toUpperCase()"
              />

              <div class="input-group-append">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="loadVehicles"
                  :disabled="board.length < 7"
                >
                  <span :class="'fas fa-search'" />
                </button>
              </div>
            </div>

            <div class="row" v-show="lostBy === 'CLIENTE'">
              <div class="form-group col-12">
                <label for="vehicles">{{ $t('vehicles') }}</label>
                <Combobox
                  :disabled="vehicles.length < 1"
                  class="bg-white"
                  name='vehicles'
                  :placeholder="$t('select_a_item')"
                  :getOptionLabel="vehicle => vehicle.VEI_PLC + ' [' + vehicle.CLI_DSC + ']'"
                  :options="vehicles"
                  :initial-value="vehicleSelected"
                  :reduce="vehicle => vehicle.VEI_ID"
                  v-model="vehicleSelected"
                />
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <b-button
              class="mt-3"
              id='closeModal'
              data-dismiss="modal"
            >
              {{ $t('close') }}
            </b-button>

            <b-button
              class="mt-3 btn-primary"
              id='closeModal'
              :disabled="!lostBy || (lostBy === 'OFICINA CREDENCIADA' && !dataToMovement.garageAccredited) || (lostBy === 'CLIENTE' && !contract)"
              @click="movement"
            >
              {{ $t('save') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL TRANSPORTE -->
    <div
      ref='modalTransport'
      id="modalTransport"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalTransport"
      aria-hidden="true"
    >
      <div class="modal-lg modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="modalTransport">
              Selecione o destinatário
            </h5>
          </div>

          <div class="modal-body">
            <b-form-group
              :label="$t('recipient')"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-radio-group
                id="radio-group-2"
                v-model="recipient"
                :aria-describedby="ariaDescribedby"
                name="radio-sub-component"
                class="d-flex justify-content-between"
              >
              <b-form-radio value="ASSISTÊNCIA">ASSISTÊNCIA</b-form-radio>
              <b-form-radio value="OFICINA CREDENCIADA">OFICINA CREDENCIADA</b-form-radio>
              <b-form-radio value="CLIENTE">CLIENTE</b-form-radio>
              </b-form-radio-group>
            </b-form-group>

            <div
              class="row"
              v-show="recipient === 'OFICINA CREDENCIADA'"
            >
              <div class="form-group col-12">
                <label for="garage_accredited">{{ $t('garage_accredited') }}</label>
                <Combobox
                  class="bg-white"
                  name='garage_accredited'
                  :hasErrors="errors.has('garage_accredited')"
                  :placeholder="$t('select_a_item')"
                  label="fantasyName"
                  :options="garages"
                  :initial-value="dataToMovement.garageAccredited"
                  :reduce="garage => garage.id"
                  v-model="dataToMovement.garageAccredited"
                  v-validate="`${validateGarage}`"
                />

                <small v-show="errors.has('garage_accredited')" class="form-text">
                  {{ errors.first('garage_accredited') }}
                </small>
              </div>
            </div>

            <div
              class="form-group"
              v-show="recipient === 'CLIENTE'"
            >
              <b-form-checkbox
                switch
                id="checkbox-1"
                name="checkbox-1"
                class="mb-3"
                v-model="contractIsActive"
              >
                Contratos ativos
              </b-form-checkbox>

              <label for="contract">{{ $t('contract') }}</label>
              <Combobox
                :disabled="loadContracts"
                class="bg-white"
                name='contract'
                :placeholder="$t('select_a_item')"
                :hasErrors="errors.has('contract')"
                :initial-value="contract"
                label="contracts"
                :options="contracts"
                v-model="contract"
                :reduce="contract => contract.id_contrato"
              />

              <small v-show="errors.has('contract')" class="form-text text-muted">
                {{ errors.first('contract') }}
              </small>
            </div>
          </div>

          <div class="modal-footer">
            <b-button
              class="mt-3"
              id='closeModal'
              data-dismiss="modal"
            >
              {{ $t('close') }}
            </b-button>

            <b-button
              class="mt-3 btn-primary"
              id='closeModal'
              :disabled="
                !recipient ||
                (recipient === 'OFICINA CREDENCIADA' && !dataToMovement.garageAccredited) ||
                (recipient === 'CLIENTE' && !contract)
              "
              @click="movement"
            >
              {{ $t('save') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL ERRORS -->
    <div
      ref='modalErrors'
      id="modalErrors"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalErrors"
      aria-hidden="true"
    >
      <div class="modal-lg modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="modalErrorsLabel">Erros encontrados</h5>
          </div>

          <div class="modal-body">
            <ul>
              <li v-for="item in modalErrors.message" :key="item.serie">
                Equipamento {{ item.serial }} {{ errorMessage[item.error] }}
              </li>
            </ul>
          </div>

          <div class="modal-footer">
            <b-button
              class="mt-3"
              id='closeModal'
              data-dismiss="modal"
            >
              {{ $t('close') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BootstrapTable from 'bootstrap-table/dist/bootstrap-table-vue.esm.js'
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import LoaderButton from '@/components/button/LoaderButton'
import allLocations from '@/config/locations'
import { request } from '@/lib/http'
import _ from 'lodash'

export default {
  name: 'ActiveMovementBatch',
  components: {
    BootstrapTable,
    LDBsTable,
    Combobox,
    LoaderButton
  },

  data () {
    return {
      columns: [
        {
          checkbox: true
        },
        {
          title: this.$t('active_type'),
          field: 'activeTypeName',
          // formatter: function(value) {
          //   return value
          //     ? value.name
          //     : '-'
          // },
          sortable: true
        },
        {
          title: this.$t('model'),
          field: 'modelName',
          // formatter: function(value, item) {
          //   return value
          //     ? value.name + ' / ' + item.manufacturer.name
          //     : '-'
          // },
          sortable: true
        },
        {
          title: this.$t('serie'),
          field: 'serie',
          sortable: true
        },
        {
          title: this.$t('location'),
          field: 'location',
          // formatter: function(value, row) {
          //   if (value === 'OFICINA CREDENCIADA') {
          //     try {
          //       return `OFICINA [${row.garageAccredited.fantasyName}]`
          //     } catch (error) {
          //       return 'OFICINA CREDENCIADA'
          //     }
          //   }

          //   if (value === 'EXTRAVIADO') {
          //     if (row.garageAccredited) {
          //       return `EXTRAVIADO / OFICINA [${row.garageAccredited.fantasyName || ''}]`
          //     }

          //     if (row.vehicleId) {
          //       return `EXTRAVIADO / CLIENTE [${row.vehicleId.CLI_DSC.toUpperCase() || ''}]`
          //     }

          //     if (row.contractData) {
          //       return `EXTRAVIADO / CLIENTE [${row.contractData.CLI_DSC.toUpperCase() || ''}]`
          //     }

          //     if (row.status) {
          //       return value + ' / ' + row.status.status.name
          //     }

          //     return value
          //   }

          //   if (value === 'VEÍCULO DO CLIENTE') {
          //     try {
          //       return `${value} / ${row.vehicleId.CLI_DSC.toUpperCase() || ''}`
          //     } catch (error) {
          //       return `${value} / SEM VEÍCULO`
          //     }
          //   }

          //   if (value === 'EM POSSE DO CLIENTE') {
          //     if (row.contractData) {
          //       return `${value} [${row.contractData.CLI_DSC.toUpperCase()}]`
          //     }
          //     if (row.client) {
          //       return `${value} [${row.client.nome_cliente.toUpperCase() || ''}]`
          //     }

          //     return '-'
          //   }

          //   if (value === 'TRANSPORTE') {
          //     if (row.garageAccredited) {
          //       return `${value} / OFICINA [${row.garageAccredited.fantasyName}]`
          //     }

          //     if (row.client) {
          //       return `${value} / CLIENTE [${row.client.nome_cliente.toUpperCase()}]`
          //     }
          //   }

          //   if (row.status) {
          //     return row.location + ' / ' + row.status.status.name
          //   }

          //   return row.location
          // },
          sortable: true
        },
        {
          title: this.$t('status'),
          field: 'activeStatusName',
          // formatter: function(value, row) {
          //   try {
          //     return value.status.name
          //   } catch (error) {
          //     return '-'
          //   }
          // }
        },
      ],
      columnsDataToMovement: [
        {
          checkbox: true
        },
        {
          title: this.$t('active_type'),
          field: 'activeTypeName',
          // formatter: function(value) {
          //   return value
          //     ? value.name
          //     : '-'
          // },
          sortable: true
        },
        {
          title: this.$t('model'),
          field: 'modelName',
          // formatter: function(value) {
          //   return value
          //     ? value.name
          //     : '-'
          // },
          sortable: true
        },
        {
          title: this.$t('manufacturer'),
          field: 'manufacturerName',
          // formatter: function(value) {
          //   return value
          //     ? value.manufacturer.name
          //     : '-'
          // },
          sortable: true
        },
        {
          title: this.$t('serie'),
          field: 'serie',
          // formatter: function(value) {
          //   return value
          //     ? value
          //     : '-'
          // },
          sortable: true
        },
      ],
      locations: allLocations,
      validateGarage: '',
      validateStatus: '',
      query: {
        id: '',
        model: undefined,
        serie: '',
        activeType: undefined,
        location: '',
        garageAccredited: '',
        status: undefined,
        isActive: true
      },
      queryToUse: {},
      trackers: [],
      fields: [
        { key: 'serial', label: this.$t('tracker') },
        { key: 'services', label: this.$t('services') },
        { key: 'reason', label: this.$t('maintance_reason') }
      ],
      contract: undefined,
      alert: {
        show   : false,
        type   : 'danger',
        message: ''
      },
      modalErrors: [],
      board: '',
      serviceToApplyAll: undefined,
      errorMessage: {
        'serialIsLocadados': 'não está vinculado a um cliente',
        'serialNoLocadados': 'está vinculado a um cliente',
        'noStatus': 'não contém o status informado',
        'trackerNoHasVehicle': 'não possui veículo no arena',
        'noTracker': 'não é RASTREADOR',
        'trackerAndLinked': 'possui SIMCARD vinculado'
      },
      lostBy: 'OUTROS',
      vehicles: [],
      vehicleSelected: undefined,
      contractIsActive: true,
      loadContracts: false,
      statusByDestiny: [],
      recipient: 'ASSISTÊNCIA'
    }
  },

  props: {
    dataToMovement: {
      type: Object,
      default: () => ({
        actives         : [],
        location        : '',
        status          : undefined,
        garageAccredited: undefined
      })
    }
  },

  watch: {
    'dataToMovement.location': function (value) {
      switch (value) {
        case 'OFICINA CREDENCIADA':
          this.validateGarage = 'required'
          this.validateStatus = 'required'
          break;
        case 'VEÍCULO DO CLIENTE':
          this.validateGarage = ''
          this.validateStatus = ''
          break;
        default:
          this.validateGarage = ''
          this.validateStatus = 'required'
          break;
      }

      if (value) {
        let statusFiltered = []

        for (const item of this.allStatus.rows) {
          if (item.hasOwnProperty('locations')) {
            item.locations.includes(value) && statusFiltered.push(item)
          }
        }

        this.statusByDestiny = statusFiltered
      }

      this.dataToMovement.status = undefined
    },

    serviceToApplyAll: function(value) {
      for (const tracker of this.trackers) {
        tracker.service = value
      }
    },

    lostBy: function(value) {
      if (value === 'OFICINA CREDENCIADA') {
        this.contract = undefined
        this.board    = ''
      }

      if (value === 'CLIENTE') {
        this.dataToMovement.garageAccredited = undefined
      }
    },

    contractIsActive: async function (value) {
      this.contract      = undefined
      this.loadContracts = true

      await this.$store.dispatch('contracts/fetchFiltered', { status: value })

      this.loadContracts = false
    },

    bstable(value) {
      let newData = value.rows

      for (const item of this.dataToMovement.actives) {
        newData = newData.filter(row => row.id != item.id)
      }

      if (newData.length != value.rows.length) {
        this.$store.dispatch('bstable/fetchAll', { ...value, rows: newData })
      }
    },

    'query.location': function(value) {
      if (!value || value !== 'OFICINA CREDENCIADA') {
        this.query.garageAccredited = ''
      }
    }
  },

  computed: {
    ...mapState({
      actives: state => state.active.all,
      garages: state => state.garageaccredited.all,
      manufacturers: state => state.manufacturer.all,
      activestypes: state => state.activestype.all,
      models: state => state.model.all,
      servicetypes: state => state.servicetypes.all,
      contracts: state => state.contracts.all,
      maintancereasons: state => state.maintancereason.all,
      allStatus: state => state.status.all,
      bstable: state => state.bstable.all,
      lastquery: state => state.filtershistory.query
    })
  },

  methods: {
    sort(name, order) {},

    clear() {
      this.query.model = '',
      this.query.serie = '',
      this.query.activeType = '',
      this.query.location = '',
      this.query.garageAccredited = ''
      this.query.status = undefined
      this.query.isActive = true
    },

    addActives(type = 'getSelections') {
      const table = $('#table')
      const selected = table.bootstrapTable(type)

      if (!selected.length) {
        return this.showError('Selecione pelo menos 1 (um) ativo para adicionar')
      }

      for (const itemSelected of selected) {
        const exists = this.dataToMovement.actives.filter(active => active.id == itemSelected.id)
        const newData = this.bstable.rows.filter(active => active.id != itemSelected.id)

        this.$store.dispatch('bstable/fetchAll', { ...this.bstable, rows: newData })

        if (!exists.length) {
          this.dataToMovement.actives.unshift(itemSelected)
        }
      }

      this.trackers = []
      return table.bootstrapTable('uncheckAll')
    },

    removeActives(type = 'getSelections') {
      const table = $('#tableDataToMovement')
      const selected = table.bootstrapTable(type)

      if (selected.length === 0) {
        return this.showError('Selecione pelo menos 1 (um) ativo para remover')
      }

      let newData = this.bstable.rows

      for (const itemSelected of selected) {
        this.dataToMovement.actives.map((active, index) => {
          if (active.id == itemSelected.id) {
            newData.unshift(active)
            this.dataToMovement.actives.splice(index, 1)
          }
        })
      }

      this.$store.dispatch('bstable/fetchAll', { ...this.bstable, rows: newData })

      this.trackers = []
      return table.bootstrapTable('uncheckAll')
    },

    showError(message) {
      return this.$store.dispatch('notify/error', { message })
    },

    async movement() {
      this.alert.show = false
      const {
        actives,
        location
      } = this.dataToMovement

      const { dispatch } = this.$store

      if (!actives.length) {
        const message = 'É necessário adicionar pelo menos 1 (um) ativo ao destino'
        return dispatch('notify/error', { message }, { root: true })
      }

      if (location !== 'OFICINA CREDENCIADA' && this.lostBy !== 'OFICINA CREDENCIADA' && this.recipient !== 'OFICINA CREDENCIADA') {
        delete this.dataToMovement.garageAccredited
      }

      if (location === 'VEÍCULO DO CLIENTE') {
        const amountTrackers = actives.filter(active => active.activeTypeId == 10)

        if (amountTrackers.length > 1) {
          return dispatch('notify/error', { message: this.$t('only1TrackerByVehicle') }, { root: true })
        }
      }

      if (this.trackers.length > 0) {
        if (!this.contract) {
          this.alert.message = 'É necessário informar o Contrato!'
          return this.alert.show = true
        }

        const invalid = message => {
          this.alert.message = message
          this.alert.show = true
        }

        for (const tracker of this.trackers) {
          if (tracker.service === undefined) {
            invalid('É necessário informar o Serviço para todos os rastreadores')
            break
          }

          if ((tracker.service === 2 || tracker.service === 6) && !tracker.reason) {
            invalid('Informe o motivo de manutenção')
            break
          }
        }

        if (this.alert.show) {
          return
        }
      }

      dispatch('overlay/show', true)

      const json = {
        ...this.dataToMovement,
        trackers: this.trackers,
        contract: this.contract,
        board   : this.board,
        vehicle : this.vehicleSelected
      }

      const result = await dispatch('active/movementBatch', json)

      $('#modalService').modal('hide')
      $('#modalExtraviado').modal('hide')
      $('#modalTransport').modal('hide')

      dispatch ('overlay/show', false)

      if (result.error) {
        $('#modalExtraviado').modal('hide')
        $('#modalInfoClient').modal('hide')
        $('#modalService').modal('hide')

        this.modalErrors = result.errors
        return $('#modalErrors').modal('show')
      }

      if (result) {
        this.dataToMovement.actives = []
        $('#search').trigger('click')
      }
    },

    async onClick() {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }

      const {
        location,
        actives
      } = this.dataToMovement

      const idActiveTypeTracker = 10

      const hasTracker = actives.filter((active) => active.activeTypeId == idActiveTypeTracker)

      if (location === 'OFICINA CREDENCIADA' && hasTracker.length > 0) {
        this.trackers = hasTracker

        return $('#modalService').modal('show')
      }

      if (location === 'VEÍCULO DO CLIENTE' || location === 'EM POSSE DO CLIENTE') {
        return $('#modalInfoClient').modal('show')
      }

      if (location === 'EXTRAVIADO') {
        return $('#modalExtraviado').modal('show')
      }

      if (location === 'TRANSPORTE') {
        const hasComplementaryField = this.allStatus.rows.find(item => item.complementaryField && item.id == this.dataToMovement.status)

        if (hasComplementaryField) {
          return $('#modalTransport').modal('show')
        }
      }

      if (location === 'RASTREADOR DESCONTINUADO') {
        const errors = []

        for (const active of actives) {
          const baseError = {
            serie: active.serie,
            serial: active.serie
          }
          const isTracker = active.activeTypeId === idActiveTypeTracker

          if (!isTracker) {
            errors.push({
              ...baseError,
              error: 'noTracker'
            })
          }

          if (isTracker && active.linked) {
            errors.push({
              ...baseError,
              error: 'trackerAndLinked'
            })
          }
        }

        if (errors.length) {
          this.modalErrors = {
            message: errors
          }

          return $('#modalErrors').modal('show')
        }
      }

      return this.movement()
    },

    async loadVehicles() {
      this.vehicles = await request({
        url   : `all-vehicles-arena/${this.board}`,
        method: 'get'
      })
    },

    customGarageLabel(garage) {
      const info = [garage.fantasyName]

      const city = _.get(garage, 'city', '')
      const uf = _.get(garage, 'uf', '')

      city && info.push(city.toUpperCase())
      uf && info.push(uf.toUpperCase())

      return info.join(' - ')
    }
  },

  beforeMount() {
    this.queryToUse = this.lastquery['activemovementbatch'] ? this.lastquery['activemovementbatch'] : this.query
  },

  async mounted() {
    const { dispatch } = this.$store

    await Promise.all([
      dispatch('status/fetchAll'),
      dispatch('garageaccredited/fetchAll'),
      dispatch('manufacturer/fetchAll'),
      dispatch('activestype/fetchAll'),
      dispatch('model/fetchAll'),
      dispatch('servicetypes/fetchFiltered', { isActive: true }),
      dispatch('maintancereason/fetchAll'),
      dispatch('contracts/fetchAll'),
    ])

    if (this.lastquery['activemovementbatch']) {
      for (const [key, value] of Object.entries(this.lastquery['activemovementbatch'])) {
        this.query[key] = value
      }
    }

    this.queryToUse = this.query

    const global = this

    $('#table').on('dbl-click-row.bs.table', function(row, $el, field) {
      $('#table').bootstrapTable('checkBy', { field: 'serie', values: [$el.serie] })

      global.addActives()
    })

    $('#tableDataToMovement').on('dbl-click-row.bs.table', function(row, $el, field) {
      $('#tableDataToMovement').bootstrapTable('checkBy', { field: 'serie', values: [$el.serie] })

      global.removeActives()
    })

    $('#modalService').on('hide.bs.modal', function () {
      global.alert.show = false
    })

    $('#modalInfoClient').on('hide.bs.modal', function () {
      global.board = ''
      global.contract = undefined
    })

    $('#modalExtraviado').on('hide.bs.modal', function () {
      global.lostBy = 'OUTROS'
      global.contract = undefined
      global.dataToMovement.garageAccredited = undefined
      global.board = ''
      global.vehicleSelected = undefined
      global.contractIsActive = true
    })

    $('#modalTransport').on('hide.bs.modal', function () {
      global.recipient = 'ASSISTÊNCIA'
      global.contract = undefined
      global.dataToMovement.garageAccredited = undefined
      global.contractIsActive = true
    })
  },

  destroyed () {
    const { dispatch } = this.$store

    dispatch('active/cleanState')
    dispatch('garageaccredited/cleanState')
    dispatch('manufacturer/cleanState')
    dispatch('activestype/cleanState')
    dispatch('model/cleanState')
    dispatch('status/cleanState')
    dispatch('filtershistory/setQuery', { key: 'activemovementbatch', query: this.query })
  }
}
</script>
